import React, {useContext} from 'react';
import MobXContext from "../../../app/mobx/MobXContext";
import {observer} from "mobx-react";
import UtahIDTypes from "./UtahIDTypes";
import ConfiguratorUtahIdPlainOutput from "./ConfiguratorUtahIdPlainOutput";
import ConfiguratorUtahIdCustomOutput from "./ConfiguratorUtahIdCustomOutput";
import OutputLine from "../Output/OutputLine";
import PropTypes from "prop-types";

const propTypes = {
	baseIndent: PropTypes.number.isRequired,
};
const defaultProps = {};

const hasSetting = (configuratorStore, configuratorType) => {
	let result = configuratorStore.utahIdType === configuratorType;
	if (result) {
		switch (configuratorType) {
			case UtahIDTypes.plain:
				result = true;
				break;

			case UtahIDTypes.custom:
				result = configuratorStore.utahIdCustom.onUserClickedSignIn ||
					configuratorStore.utahIdCustom.onUserClickedSignOut ||
					configuratorStore.utahIdCustom.profileURL;
				break;

			default:
				console.error(`hasSetting(): Unknown configuratorType: '${configuratorType}'`);
				break;
		}
	}
	return result;
};

const ConfiguratorUtahIdOutput = ({baseIndent}) => {
	const {configuratorStore} = useContext(MobXContext);

	return (
		(configuratorStore.utahIdType === UtahIDTypes.on ? <OutputLine indent={baseIndent}>{`utahId: true,`}</OutputLine> : undefined) ||
		(hasSetting(configuratorStore, UtahIDTypes.plain) ? <ConfiguratorUtahIdPlainOutput baseIndent={baseIndent}/> : undefined) ||
		(hasSetting(configuratorStore, UtahIDTypes.custom) ? <ConfiguratorUtahIdCustomOutput baseIndent={baseIndent}/> : undefined) ||
		null
	);
};

ConfiguratorUtahIdOutput.propTypes = propTypes;
ConfiguratorUtahIdOutput.defaultProps = defaultProps;

export default observer(ConfiguratorUtahIdOutput);
